
export class QuotationAdditionalFieldDO {

	public  id:Number;
	
	public fieldKey: String = null;

	public fieldValue: String = null;

	public getId() {
		return this.id;
	}
	public setId(id: Number) {
		this.id = id;
	}
	public getFieldKey() {
		return this.fieldKey;
	}
	public setFieldKey(fieldKey) {
		this.fieldKey = fieldKey;
	}
	public getFieldValue() {
		return this.fieldValue;
	}
	public setFieldValue(fieldValue) {
		this.fieldValue = fieldValue;
	}

}
